import { EProductType } from "@devowl-wp/api-real-commerce";
/**
 * Whether a product represents a paid human service (Cookie-Expert setup,
 * generic commissioned work) rather than a software license. Plugin licenses
 * — including one-time lifetime plans — return `false`.
 */ function isPaidService(type) {
    return type === EProductType.GeneralService || type === EProductType.CookieExpertService;
}
export { isPaidService };
